import fetchApiWithAuth from './fetch';

export type SelfWarehouse = {
  id: number;
  external_id: string;
  name: string;
  address: string | null;
  is_default: boolean;
  reserve_priority: number;
  /** Daily ordered-units limit; 0 = off. */
  order_limit_self: number;
  /** Local switch; false → excluded from MP stock aggregation. */
  is_active: boolean;
  deleted_at: string | null;
};

async function readError(result: Response, fallback: string): Promise<string> {
  const text = await result.text();
  try {
    const json = JSON.parse(text);
    if (typeof json?.message === 'string') return json.message;
    if (Array.isArray(json?.message)) return json.message.join(', ');
  } catch {
    /* plain text */
  }
  return text || fallback;
}

export async function getAll(): Promise<SelfWarehouse[]> {
  const result = await fetchApiWithAuth('/api/self_warehouses');
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка загрузки складов'));
  }
  return result.json();
}

export async function create(body: {
  external_id: string;
  name?: string;
  address?: string | null;
  is_default?: boolean;
  reserve_priority?: number;
}): Promise<SelfWarehouse> {
  const result = await fetchApiWithAuth('/api/self_warehouses', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка создания склада'));
  }
  return result.json();
}

export async function update(
  id: number,
  body: {
    name?: string;
    address?: string | null;
    external_id?: string;
    reserve_priority?: number;
    order_limit_self?: number | null;
    is_active?: boolean;
  },
): Promise<SelfWarehouse> {
  const result = await fetchApiWithAuth(`/api/self_warehouses/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка обновления склада'));
  }
  return result.json();
}

export async function setDefault(id: number): Promise<SelfWarehouse> {
  const result = await fetchApiWithAuth(
    `/api/self_warehouses/${id}/set_default`,
    { method: 'POST' },
  );
  if (!result.ok) {
    throw new Error(
      await readError(result, 'Ошибка назначения склада по умолчанию'),
    );
  }
  return result.json();
}

export async function remove(id: number): Promise<void> {
  const result = await fetchApiWithAuth(`/api/self_warehouses/${id}`, {
    method: 'DELETE',
  });
  if (!result.ok) {
    throw new Error(await readError(result, 'Ошибка удаления склада'));
  }
}
